import React from "react";
import { Grid, Link, Paper, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { findFollowUpReason, IFollowUpIssueInput } from "../../prescription_lifecycle/components/prescription/followUp";
import { buildPharmacistUrl } from "../../prescription_lifecycle/components/prescription/ccsLinks";

interface IProps {
  title: string;
  prescriptionId: string;
  issues: IFollowUpIssueInput[];
}

/** Final state of the Route to Follow-Up step. */
const FollowUpResultCard: React.FC<IProps> = ({ title, prescriptionId, issues }) => (
  <Grid item xs={12} style={{ width: "100%", maxWidth: 1200 }}>
    <Paper style={{ padding: 24 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Alert severity="success" style={{ marginBottom: 16 }}>
        Prescription {prescriptionId} was routed to follow-up with {issues.length}{" "}
        {issues.length === 1 ? "issue" : "issues"}. It can't be ordered until the follow-up is resolved.
      </Alert>
      <ol style={{ marginTop: 0 }}>
        {issues.map((issue) => {
          const reason = findFollowUpReason(issue.reasonCode);
          return (
            <li key={issue.reasonCode} style={{ marginBottom: 8 }}>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                {reason ? reason.label : issue.reasonCode}
                {reason && (
                  <Typography component="span" variant="caption" color="textSecondary" style={{ marginLeft: 8 }}>
                    {reason.category}
                  </Typography>
                )}
              </Typography>
              <Typography variant="body2">{issue.followupQuestion}</Typography>
            </li>
          );
        })}
      </ol>
      <Link href={buildPharmacistUrl(prescriptionId)} target="_blank" rel="noopener noreferrer">
        Open in CCS
      </Link>
      <Typography variant="caption" color="textSecondary" component="span" style={{ marginLeft: 8 }}>
        Requires CCS (Clinical Checking Service) access.
      </Typography>
    </Paper>
  </Grid>
);

export default FollowUpResultCard;
